// Admin Utilities (Android AdminUtilsFragment / UpdateOrderFragment / GetCustomerPhoneVerificationCodeFragment) —
// same endpoints and params as the Android technician app (api/v3/pro/utilities/*).
// Every call resolves to { ok, body, message } and never throws.
import { apiCall } from "./apiCall";

export const adminUtilitiesApi = {
  // Update Price: { id, total, preferred_payment_type, preferred_payment_type_text, payment_types: [{ key, value }] }
  orderPrice: (orderId) => apiCall("get", `utilities/orders/price/${orderId}`),
  updateOrderPrice: (orderId, newAmount, paymentType) => apiCall("put", `utilities/orders/price/${orderId}`, {
    order_id: orderId, new_amount: newAmount, payment_type: paymentType,
  }),

  // Edit Summary: checks the order exists; tech-web then opens its own System Summary page (Edit Summary on it)
  orderSummaryEdit: (orderId) => apiCall("get", `utilities/orders/summary/edit/${orderId}`),

  // Change Installation Date: { id, installation_datetime, inspection_datetime, invoice_datetime, invoice_paid_datetime } (unix seconds)
  orderDates: (orderId) => apiCall("get", `utilities/orders/datetime/${orderId}`),
  // any of installation_datetime, inspection_datetime, invoice_datetime, invoice_paid_datetime (unix seconds) → { msg }
  updateOrderDates: (orderId, params) => apiCall("put", `utilities/orders/datetime/${orderId}`, params),

  // Update Address: { id, order_id, address, lat, long, city, state, postal_code }
  orderAddress: (orderId) => apiCall("get", `utilities/orders/address/${orderId}`),
  updateOrderAddress: (orderId, params) => apiCall("put", `utilities/orders/address/${orderId}`, params),
  // Google place → address parts (address_1, city_id, state_id, postal_code, lat, long)
  formattedAddress: (params) => apiCall("get", "formatted/address/get", params),

  // Get Customer Phone Verification Code → { code }
  verificationCode: (phone) => apiCall("get", "utilities/consumers/verification-code", { phone }),
};

// Android AdminUtilsFragment "Heat Load Calculator" opens this page in the browser
export const HEAT_LOAD_CALCULATOR_URL = "https://www.highseer.com/pages/hvac-load-calculator";
